import React from "react";

interface Props {
  onClick: () => void;
  icon: React.ReactNode;
  disabled: boolean;
}

export default function ControlsButton({ onClick, icon, disabled }: Props) {
  return (
    <button
      onClick={onClick}
      type='button'
      disabled={disabled}
      className='rounded-xl bg-white border p-2 md:p-3 hover:bg-gray-50 active:bg-gray-100 disabled:text-gray-200 disabled:hover:bg-white disabled:active:bg-white'
    >
      {icon}
    </button>
  );
}
